
import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Col, Row} from "reactstrap";


class BigIconButton extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <Button
            onClick={this.props.buttonOnClick}
            className={"width-100 button-gray"}>
            <img
                src={this.props.buttonIcon}
                className={"img-fluid icon-padding"}
            />
            <br />
            <span className={"text-icon-button"}>
                {i18n.t(this.props.buttonText)}
            </span>

        </Button>
    }
}

export default translate("translations")(BigIconButton);